import { Helmet } from "react-helmet-async";
import { BRAND, getSection } from "@/lib/siteSeo";

// -----------------------------------------------------------------------------
// SeoHead — drop this at the top of any page render to inject the correct
// <title>, meta description, meta keywords, and Open Graph / Twitter card
// values.
//
// Usage:
//   <SeoHead section="family_tree" />
//   <SeoHead
//     section="obituaries"
//     title="Obituaries in Kerala | SocialPulse"    // optional override
//     description="…"
//     image="https://…"
//     url="https://socialpulse.com/obituaries"
//   />
// -----------------------------------------------------------------------------

const DEFAULT_IMAGE = "https://socialpulse.com/assets/social-pulse-logo.jpg";

export default function SeoHead({
  section,
  title,
  description,
  image = DEFAULT_IMAGE,
  url,
  type = "website",
}) {
  const cfg = section ? getSection(section) : {};
  const resolvedTitle =
    title ||
    cfg.meta_title ||
    (cfg.tagline
      ? `${cfg.tagline.replace(/\.$/, "")} | ${BRAND.name}`
      : "SocialPulse | Global Community, Family Tree & Memorial Platform");
  const resolvedDesc =
    description ||
    cfg.meta_desc ||
    "Discover communities, build your family tree, create memorials, explore local places, events, businesses, food, history, Civic Reports and more with SocialPulse.";
  const ogDesc = cfg.og_desc || resolvedDesc;

  return (
    <Helmet>
      <title>{resolvedTitle}</title>
      <meta name="description" content={resolvedDesc} />
      {cfg.tagline && <meta name="tagline" content={cfg.tagline} />}
      <meta property="og:site_name" content={BRAND.name} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={resolvedTitle} />
      <meta property="og:description" content={ogDesc} />
      {url && <meta property="og:url" content={url} />}
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={resolvedTitle} />
      <meta name="twitter:description" content={ogDesc} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
